
import styled from 'styled-components';
import React, { useState, useEffect } from 'react';
import importImage from './ImportImage'

const Wrapper = styled.div`
 
 
  display: flex;
 
  margin: 10px 0 20px 0;
  color: white;
  @media (max-width: 965px) {
  color: black;
 
}
`;

const Image = styled.img`
 
 padding: 0px 0 0px 50px;
 width: 80px;
 position: relative;  
  z-index: 10;  
 display: flex;
 float: left;
 margin: 0;  

`;
const NavBar = styled.nav`
  position: fixed;
  top: ${({ $visible }) => ($visible ? '24px' : '-100px')};
  left: 0;
  width: 100%;
  z-index: 1000;
  transition: top 0.3s ease-in-out;

  ul {
    display: flex;
    justify-content: flex-end;
    list-style: none;
    margin: 0 60px 0 0;
    padding: 20px;
  }

  a {
    text-decoration: none;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 8px;
    color: inherit;
    font-size: 20px;

    &:hover {
      color: red;
    }
  }
      @media (max-width: 965px) {
    top: ${({ $visible }) => ($visible ? '0' : '-100px')};
    padding-top: 20px;
    padding-bottom: 20px;
 background-color: black;
    ul {
      display: flex;
      flex-direction: column;
      width: 100%;
      position: absolute;
      left: 0;
      opacity: 0;
      padding-top: 120px;
      color: white;
      transition: top 0.5s ease, opacity 0.4s ease;
      background-color: black;
    }

    ul.active {
      top: 0px;
      opacity: 1;
    }

    li {
      text-align: start;
      padding-bottom: 30px;
    }
  }
  
    
    `;
 
    const Button  = styled.button`
      display: none;
      @media (max-width: 965px) {
      display: flex;
      justify-content: center;
      align-items: center;
      top: 18px;
 
      border: none;
      width: 56px;
      height: 56px;
      background-color: transparent;
      cursor: pointer;
      position: absolute;  
    
      right: 20px;   
  }
  
    `;

function Nav({ onClick, ...props }) {
  const [imageSrc1, setImageSrc1] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [prevScrollPos, setPrevScrollPos] = useState(window.scrollY);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const loadImages = async () => {
      await importImage('tongfei.png', setImageSrc1);
    };
    loadImages();
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Scroll listener
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const isScrollingUp = currentScrollPos < prevScrollPos;

      setVisible(isScrollingUp || currentScrollPos < 10); // show if scrolling up or near top
      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [prevScrollPos]);
        return (
         <Wrapper>
      <NavBar $visible={visible} {...props}>
        <Image src={imageSrc1} onClick={onClick} style={{ cursor: "pointer" }} />
        <ul className={isMenuOpen ? 'active' : ''}>
          <li><a href="#about-me">Home</a></li>
          <li><a href="#menu">Menu</a></li>
          <li><a href="#info">Location</a></li>
        </ul>
        <Button onClick={toggleMenu}>
          <i className="fa fa-bars" style={{ fontSize: "24px", color: 'white' }}></i>
        </Button>
      </NavBar>
    </Wrapper>
        )

    }



    export default Nav